import Vue from "vue";
import Router from "vue-router";
import bootstrapRouter from './bootstrap';
import vuetifyRouter from "./wizzard";

Vue.use(Router);

const appRouter = [
  {
    path: "/",
    redirect: "/dashboard",
    component: () => import("@/layout/Layout"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/view/Dashboard.vue"),
      },
      {
        path: "/device",
        name: "device",
        component: () => import("@/view/Device.vue"),
      }
    ],
  },
  {
    path: "/",
    component: () => import("@/view/auth/login_pages/Login-2"),
    children: [
      {
        name: "login",
        path: "/login",
        component: () => import("@/view/auth/login_pages/Login-2"),
      },
      {
        name: "register",
        path: "/register",
        component: () => import("@/view/auth/login_pages/Login-1"),
      },
    ],
  },
  {
    path: "*",
    redirect: "/404",
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/view/error/Error-1.vue"),
  },
]

const routes = [...vuetifyRouter, ...bootstrapRouter, ...appRouter];


const router = new Router({
  routes
});

export default router;
